import { router, usePage } from "@inertiajs/react"
import { useEffect, useState } from "react"
import { toast } from "sonner"
import { CheckCircle, AlertCircle } from "lucide-react"

import type { Flash } from "@/types"

const emptyFlash = {}

export const useFlash = () => {
  const { flash } = usePage<{ flash: Flash }>().props
  const [currentFlash, setCurrentFlash] = useState<Flash>(emptyFlash)

  useEffect(() => {
    setCurrentFlash(flash)
  }, [flash])

  router.on("start", () => {
    setCurrentFlash(emptyFlash)
  })

  useEffect(() => {
    if (currentFlash.alert) {
      toast.error(currentFlash.alert, {
        icon: <AlertCircle className="h-4 w-4 text-red-500" />,
      })
    }
    if (currentFlash.notice) {
      toast(currentFlash.notice, {
        icon: <CheckCircle className="h-4 w-4 text-green-500" />,
      })
    }
  }, [currentFlash])
}
